/**
 * Created by charnjeetelectrovese@gmail.com on 12/27/2019.
 */

import {serviceFetchSpotlites, serviceUpdateProvider} from '../services/Spotlite.service';
// import { fetchSpotlites } from '../services/User.service';
import store from '../store';
import Constants from '../config/constants';

export const FETCH_INIT = 'FETCH_INIT_SPOTLITES';
export const FETCHED = 'FETCHED_SPOTLITES';
export const FETCHED_FAIL = 'FETCHED_FAIL_SPOTLITES';
export const FETCHED_FILTER = 'FETCHED_FILTER_SPOTLITES';
// export const NEXT_SPOTLITES = 'NEXT_SPOTLITES';
// export const PREV_SPOTLITES = 'PREV_SPOTLITES';
export const FETCH_NEXT = 'FETCH_NEXT_SPOTLITES';
export const FILTER = 'FILTER_SPOTLITES';
export const RESET_FILTER = 'RESET_FILTER_SPOTLITES';
export const SET_SORTING = 'SET_SORTING_SPOTLITES';
export const SET_FILTER = 'SET_FILTER_SPOTLITES';
export const SET_PAGE = 'SET_PAGE_SPOTLITES';
export const CHANGE_PAGE = 'CHANGE_PAGE_SPOTLITES';
export const CHANGE_STATUS = 'CHANGE_STATE_SPOTLITES';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_SPOTLITES';

export function actionFetchSpotlites(index = 1, sorting = {}, filter = {}, shouldReset=false) {
    const request = serviceFetchSpotlites({index, row: sorting.row, order: sorting.order, ...filter});
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: {data: data.data, page: index}});
                dispatch({type: SET_SERVER_PAGE, payload: index});
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}


export function actionChangePageSpotlites(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

// export function nextSpotlitesClick() {
//     return {
//         type: NEXT_SPOTLITES,
//         payload: null,
//     };
// }
//
// export function prevSpotlitesClick() {
//     return {
//         type: PREV_SPOTLITES,
//         payload: null,
//     };
// }

export function actionFilterSpotlites(value) {
    const request = serviceFetchSpotlites(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});
        });
    };
}


export function actionChangeStatusSpotlites(params) {
    console.log('params', params);
    return (dispatch) => {

        dispatch({
            type: CHANGE_STATUS, payload: {
                id: params.id,
                status: params.status,
                note: params.note ? params.note : '',
            }
        });
    };
}

export function actionResetFilterSpotlites() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageSpotlites(page) {
    const stateData = store.getState().spotlites;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchSpotlites(serverPage + 1, sortingData, {query, query_data: queryData}));
        // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    }

    console.log(currentPage, totalLength);
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
    // if (this.props.totalUsers <= ((this.props.currentPage + 1) * 100)) {
    //         // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order);
    //         this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    //     }

}
